import { clientInstance } from "../config/config";

export let getMyProgressAPI = async () => {
    return clientInstance.get(`/progress`);
}

export let getStudentProgressAPI = async (studentId) => {
    return clientInstance.get(`/progress/student/${studentId}`);
}

